import type { DateTime } from 'luxon';
import { get, writable } from 'svelte/store';
import { now } from './time';

type DateRange = {
	start: DateTime;
	end: DateTime;
};

export const calendarDateRange = writable<DateRange>({
	start: get(now).minus({ months: 1 }).startOf('month'),
	end: get(now).plus({ months: 12 }).endOf('month')
});

export const dateSelected = writable<DateTime>(get(now));

dateSelected.subscribe((date) => {
	if (date < get(calendarDateRange).start) {
		calendarDateRange.update((range) => ({ ...range, start: date.startOf('month') }));
	} else if (date > get(calendarDateRange).end) {
		calendarDateRange.update((range) => ({ ...range, end: date.endOf('month') }));
	}
});

export function resetDates() {
	calendarDateRange.set({
		start: get(now).minus({ months: 1 }).startOf('month'),
		end: get(now).plus({ months: 12 }).endOf('month')
	});

	dateSelected.set(get(now));
}
